import { render } from "./Files.vue?vue&type=template&id=10c8f696"
import script from "./Files.vue?vue&type=script&lang=ts"
export * from "./Files.vue?vue&type=script&lang=ts"

import "./Files.vue?vue&type=style&index=0&id=10c8f696&lang=scss"
script.render = render

export default script